import { useState } from "react";
import Modal from 'react-modal';
import MessageModalContent from "./MessageModalContent";

type MessageModalProps = {
    type: "success" | "danger" | "info" | "warning" | "general";
    message: string;
    closeAction?: () => void;
    isLongMessage?: boolean
  };
  
  
  
  export default function MessageModal({
    type, message, closeAction, isLongMessage
  }: MessageModalProps) {
    const [modalIsOpen, setIsOpen] = useState(true);
    Modal.setAppElement("#root");


    function closeModal() {
        setIsOpen(false);
        if(closeAction) {
          closeAction();
        }
    }


    return (
      <Modal isOpen={modalIsOpen}>
        <div className="modale open">
          <div className="modale--content">
              <MessageModalContent message={message} type={type} closeAction={closeModal} isLongMessage={isLongMessage} />
          </div>
        </div>
      </Modal>
    );
  }